import { semanticTokensSD, themeColorsSD } from "./sd";
import { semanticTokensETH, themeColorsETH } from "./eth";
import { semanticTokensBNB, themeColorsBNB } from "./bnb";
import { semanticTokensPolygon, themeColorsPolygon } from "./polygon";

import { BNB, ETH, POLYGON, SD } from "@constants/constants";

export const getThemeColors = (token: string | undefined) => {
  switch (token) {
    case SD:
      return themeColorsSD;
    case ETH:
      return themeColorsETH;
    case BNB:
      return themeColorsBNB;
    case POLYGON:
      return themeColorsPolygon;
    // TODO default Theme
  }
};

export const getSemanticTokens = (token: string | undefined) => {
  switch (token) {
    case SD:
      return semanticTokensSD;
    case ETH:
      return semanticTokensETH;
    case BNB:
      return semanticTokensBNB;
    case POLYGON:
      return semanticTokensPolygon;
    // TODO default Theme
  }
};
